import CaptchaDialog from './dialog.js'

const components = {}

function install(Vue) {
  Vue.$CaptchaDialog = Vue.prototype.$CaptchaDialog = CaptchaDialog
}

if (typeof window !== undefined && window.Vue) {
  install(window.Vue)
}

components.install = install

export default components



// WEBPACK FOOTER //
// ./web/components/captchaDialog/index.js